import instance from './instance';

export function updateComment({ uuid, data }) {
  return instance.put(`/workspace_comments/${uuid}`, data);
}

export function createComment(data) {
  return instance.post('/workspace_comments', data);
}

export function destroyComment({ uuid, data }) {
  return instance.delete(`/workspace_comments/${uuid}`, { data });
}

export function destroyCommentAttachments(attachmentId) {
  return instance.delete('/workspace_comments/destroy_attachment', { attachmentId });
}
